import { Button, Grid, TextField } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme, withStyles
} from "@material-ui/core/styles";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useHistory } from "react-router-dom";
import {
  getProjects,
  getProjectSampleAllData,
  UploadStorage,
} from "../../store/actions";
import ExportSample from "./ExportSampleStorage";
import Api from "../../../../helpers/api";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    card: {
      height: "100%",
      padding: "20px",
    },
    cardContent: {
      textAlign: "center",
    },
    center: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    text: { color: "black" },
  })
);
interface Props {
  key: number;
  getProjects: any;
  loading: any;
  projects: any;
  getProjectSampleAllData: any;
  sampleAllData: any;
  UploadStorage: any;
}
const StopsPlace: React.FC<Props> = ({
  key,
  loading,
  getProjects,
  projects,
  getProjectSampleAllData,
  sampleAllData,
  UploadStorage,

}) => {
  const [project, setProject] = React.useState<any>("");
  const [page, setPage] = useState(0);
  const timer = useRef<any>(0);
  const [file, setFile] = React.useState<any>("");
  const [projectSampleData, setProjectSampleData] = useState<any>();
  const history = useHistory();
  const [clearIt, setClearIt] = useState<number>(1);

  const uploadStorageFile = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("file", file);
    await UploadStorage(formData);
    getProjectSampleAllData();
    setFile("");
    setClearIt(clearIt === 1 ? 2 : 1);
  };
  useEffect(() => {
    getProjects();

  }, []);
  const handleExport = () => {
    if (project) {
      Api.get("/genomics/project-samples", { project: project?._id, limit: 2500 }).then((data: any) => {
        setProjectSampleData(data);
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid container xs={12}>
        <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Sample Storage Export Data</h2>
        <form onSubmit={uploadStorageFile} style={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Autocomplete
                id="Project"
                onChange={(event, newValue) => {
                  setProject(newValue);
                  setProjectSampleData(null);
                }}
                options={projects?.results || []}
                blurOnSelect
                getOptionLabel={(option: any) => {
                  return (
                    (option?.projectId) +
                    " " +
                    (option?.institute?.name || "") +
                    " " +
                    (option?.scientist?.name || "") +
                    "," +
                    (option?.dealer?.firmName || "")
                  );
                }}
                onInputChange={(event, newInputValue) => {
                  let data = newInputValue.split(" ");
                  clearTimeout(timer.current);
                  timer.current = setTimeout(() => {
                    if (data.length > 0) {
                      getProjects(`?projectId=${data[0]}`);
                    }
                  }, 1000);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    label="Project ID"
                    placeholder="Search ID/Client/Dealer Name"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button
                style={{ backgroundColor: "#14a37f", color: "white" }}
                variant="contained"
                fullWidth
                onClick={handleExport}
                disabled={project === ""}
              >
                Export
              </Button>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <input
                key={clearIt}
                type="file"
                onChange={(e: any) => setFile(e.target.files[0])}
                accept=".csv"
              />
              <sub><h6>*Upload .csv</h6></sub>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Button
                style={{ backgroundColor: "#9c27b0", color: "white" }}
                variant="contained"
                fullWidth
                onClick={uploadStorageFile}
                disabled={file === ""}
              >
                Upload
              </Button>
            </Grid>
            <ExportSample rateListExport={projectSampleData} loading={loading} />
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData
});
export default connect(mapStateToProps, {
  getProjects,
  getProjectSampleAllData,
  UploadStorage

})(StopsPlace);
